<template>
<v-currency-field v-model="internalValue" :label="label" suffix="ریال" maxlength="18" v-bind="$attrs" v-on="$listeners" @keydown="appendThreeZeros" :rules="fieldRules" />
</template>

<script>
export default {
  name: 'MyCurrency',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalValue: this.sanitize(this.value),
    }
  },
  computed: {
    fieldRules() {
      const sanitize = this.sanitize
      const isRequired = this.required
      return [
        v => {
          if (!isRequired) return true
          const cleaned = sanitize(v) // "1,234" -> "1234"
          if (!cleaned) {
            return 'این فیلد الزامی است'
          }
          const num = Number(cleaned)
          // const num = cleaned === '' ? 0 : Number(cleaned)
          return (num > 0) || 'این فیلد الزامی است و باید بزرگتر از صفر باشد'
        }
      ]
    }
  },
  watch: {
    value(v) {
      const cleaned = this.sanitize(v)
      if (cleaned !== this.internalValue) this.internalValue = cleaned
    },
    internalValue(v) {
      const cleaned = this.sanitize(v)
      if (cleaned !== v) this.internalValue = cleaned
      this.$emit('input', cleaned)
    }
  },
  methods: {
    sanitize(v) {
      let cleaned = String(v ?? '').replace(/\D/g, '')
      cleaned = cleaned.replace(/^0+/, '')
      if (cleaned.length > 15) cleaned = cleaned.slice(0, 15)
      return cleaned
    },
    appendThreeZeros(e) {
      if (e.key === '+' || e.key === '=') {
        const numericValue = Number(this.sanitize(this.internalValue) || 0)
        this.internalValue = this.sanitize(numericValue * 1000)
        e.preventDefault()
      }
    }
  }
}
</script>
